/** Light, near-white basemap — suitable for embedded maps (e.g. municipality comparison). */
export const MAPBOX_STYLE_LIGHT_V11 = 'mapbox://styles/mapbox/light-v11';
